import {
  CalculatedValuesPayload,
  EventTypeMap,
  FormStoreEventPayload,
  FormStoreEvents,
  OffshoreFormStoreInitPayload,
} from '@navstation-portal/reporting/data-model/offshore-report';
import { type } from '@ngrx/signals';
import { EventCreator, eventGroup } from '@ngrx/signals/events';

export type FormStoreEventGroup = {
  [K in keyof EventTypeMap]: EventCreator<`[${string}] ${K}`, EventTypeMap[K]>;
};

export function createFormStoreEvents(storeName: string): FormStoreEventGroup {
  return eventGroup<string, FormStoreEvents>({
    source: storeName,
    events: {
      initialiseFormState: type<OffshoreFormStoreInitPayload>(),
      updateFormStateTouched: type<FormStoreEventPayload>(),
      updateFormStatePristine: type<FormStoreEventPayload>(),
      updateFormStateStatus: type<FormStoreEventPayload>(),
      updateFormStateValue: type<FormStoreEventPayload>(),
      calculatedValuesChanged: type<CalculatedValuesPayload>(),
    },
  });
}
